/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, max: NonNullable<unknown> }} Shop_Home_Count_RowsInputs */

const vi_shop_home_count_rows = /** @type {(inputs: Shop_Home_Count_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}/${i?.max}`)
};

/**

* @param {Shop_Home_Count_RowsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_count_rows = /** @type {((inputs: Shop_Home_Count_RowsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Count_RowsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_count_rows(inputs)
});